/* eslint-disable no-extra-boolean-cast */

import React from 'react';
import _merge from 'lodash/merge';
import ReactDOMServer from 'react-dom/server';
export function isClassComponent(component) {
  return typeof component === 'function' && !!component.prototype.isReactComponent;
}
export function isFunctionComponent(component) {
  return typeof component === 'function' && String(component).includes('return React.createElement');
}
export function isComponentNull(component) {
  /* Renders a component and decides if the resulting rendered
   * HTML of the component is defined (not null)
   * */
  return !Boolean(ReactDOMServer.renderToStaticMarkup(component));
}
function isElement(element) {
  return /*#__PURE__*/React.isValidElement(element);
}
export function createComponentFromType(type, props) {
  return /*#__PURE__*/React.createElement(type, props);
}
export function createComponentFromFunction(func, props) {
  return func(props);
}
export function createComponent(typeOrFunc, props) {
  if (isClassComponent(typeOrFunc)) {
    return /*#__PURE__*/React.createElement(typeOrFunc, props);
  }
  if (isFunctionComponent(typeOrFunc)) {
    return createComponentFromFunction(typeOrFunc, props);
  }
  if (isElement(typeOrFunc)) {
    return /*#__PURE__*/React.cloneElement(typeOrFunc, _merge({}, typeOrFunc.props, props));
  }
  return createComponentFromType(typeOrFunc, props);
}